export default "__VITE_ASSET__Bb5h8Hqp__"